export default [
  {
    path: '/collection/virtual-account',
    name: 'Virtual Account',
    redirect: '/collection/virtual-account/list',
    meta: {
      icon: 'icon-collection',
      resourceCode: 'collection:virtualAccount',
    },
  },
  {
    path: '/collection/virtual-account/list',
    name: 'Virtual Account',
    component: () => import('@/views/collection/virtual-account/list/index.vue'),
    meta: {
      resourceCode: 'collection:virtualAccount:list',
      activeMenu: '/collection/virtual-account',
      parentPermissionType: 'menu',
    },
  },
  {
    path: '/collection/virtual-account/add',
    name: 'Virtual Account Add',
    component: () => import('@/views/collection/virtual-account/add/index.vue'),
    meta: {
      resourceCode: 'collection:virtualAccount:add',
      activeMenu: '/collection/virtual-account',
      hideMenu: true,
    },
  },
  {
    path: '/collection/virtual-account/detail',
    name: 'Virtual Account Detail',
    component: () => import('@/views/collection/virtual-account/detail/index.vue'),
    meta: {
      resourceCode: 'collection:virtualAccount:detail',
      activeMenu: '/collection/virtual-account',
      name: 'message.collection.vaAccountDetails',
    },
  },
  {
    path: '/collection/virtual-account/recharge',
    name: 'Virtual Account Recharge',
    component: () => import('@/views/collection/virtual-account/recharge/index.vue'),
    meta: {
      resourceCode: 'collection:virtualAccount:recharge',
      activeMenu: '/collection/virtual-account',
      hideMenu: true,
    },
  },
  {
    path: '/collection/transaction',
    name: 'Found collection transaction',
    component: () => import('@/views/collection/transaction/list/index.vue'),
    meta: {
      resourceCode: 'collection:transaction',
      activeMenu: '/collection/virtual-account',
      parentPermissionType: 'menu',
    },
  },
  {
    path: '/collection/transaction/view',
    name: 'Found collection transaction details',
    component: () => import('@/views/collection/transaction/view/index.vue'),
    meta: {
      resourceCode: 'collection:transaction:view',
      activeMenu: '/collection/virtual-account',
      name: 'message.collection.vaTransDetails',
    },
  },
];
